<div class="align-with-nav">
    <h1 class="title-heading"> {{ title }}</h1>
    <ul class="light-nav">
        <li><a [routerLink]='"../"'>Programming</a></li>
    </ul>
</div>
<app-article [articleModel]='this.article'></app-article>
